// Next Imports
import { Link } from 'react-router-dom'

// MUI Imports
import Button from '@mui/material/Button'
import { styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
// Third-party Imports
import classnames from 'classnames'

// Type Imports

// Hook Imports
// Styled Components
const MaskImg = styled('img')({
  blockSize: 'auto',
  maxBlockSize: 355,
  inlineSize: '100%',
  position: 'absolute',
  insetBlockEnd: 0,
  zIndex: -1
})

const NotFound = () => {
  const { __ } = useTranslator()
  // Vars
  const lightImg = '/images/pages/misc-mask-light.png'

  // Hooks
  const theme = useTheme()
  const hidden = useMediaQuery(theme.breakpoints.down('md'))
  const miscBackground = lightImg

  return (
    <div className='flex items-center justify-center min-bs-[100dvh] relative p-6 overflow-x-hidden'>
      <div className='flex items-center flex-col text-center'>
        <div className='flex flex-col gap-2 is-[90vw] sm:is-[unset] mbe-6'>
          <Typography variant='h4'> {__('Page Not Found :(')}</Typography>
          <Typography>{__('Oops! 😖 The requested URL was not found on this server.')}</Typography>
        </div>
        <Button component={Link} to='/cms' variant='contained' className='rounded-full w-[280px]'>
          Back To Home
        </Button>
        <img
          alt='error-404-illustration'
          src='/images/illustrations/auth/Illustration.png'
          className='object-cover bs-[400px] md:bs-[450px] lg:bs-[500px] mbs-10 md:mbs-14 lg:mbs-20'
        />
      </div>
      {!hidden && (
        <MaskImg
          alt='mask'
          src={miscBackground}
          className={classnames({ 'scale-x-[-1]': theme.direction === 'rtl' })}
        />
      )}
    </div>
  )
}

export default NotFound
